import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import { PM_PROVIDERS } from 'common/constants/constants';
import { resourceAllocationTypesEnum } from '@linearb/linjs-common';
import useJiraEpicsCols from './jira.epics.cols';
import useJiraProjectsCols from './jira.projects.cols';
import useJiraInitiativesCols from './jira.initiatives.cols';
import useAzureProjectsCols from './azure.projects.cols';
import useAzureEpicsCols from './azure.epics.cols';
import useAzureFeaturesCols from './azure.features.cols';
import useRaCostSetting from '../../settings/hooks/useRaCostSetting';
import useJiraLabelsCols from './jira.labels.cols';
import useAzureTagsCols from './azure.tags.cols';
import useAzureCustomFieldCols from './azure.custom-field.cols';
import useJiraCustomFieldCols from './jira.custom-field.cols';
import useDynamicIssueTypeCols from './dynamic_issue_type.cols';

const mapResourceTypeToColsHook = {
  [PM_PROVIDERS.JIRA]: {
    [resourceAllocationTypesEnum.PROJECT]: useJiraProjectsCols,
    [resourceAllocationTypesEnum.EPIC]: useJiraEpicsCols,
    [resourceAllocationTypesEnum.INITIATIVE]: useJiraInitiativesCols,
    [resourceAllocationTypesEnum.LABEL]: useJiraLabelsCols,
    [resourceAllocationTypesEnum.CUSTOM_FIELD]: useJiraCustomFieldCols,
    [resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE]: useDynamicIssueTypeCols
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    [resourceAllocationTypesEnum.PROJECT]: useAzureProjectsCols,
    [resourceAllocationTypesEnum.EPIC]: useAzureEpicsCols,
    [resourceAllocationTypesEnum.FEATURE]: useAzureFeaturesCols,
    [resourceAllocationTypesEnum.LABEL]: useAzureTagsCols,
    [resourceAllocationTypesEnum.CUSTOM_FIELD]: useAzureCustomFieldCols,
    [resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE]: useDynamicIssueTypeCols
  }
};

const useTableCols = ({ resourceType }) => {
  const pmProvider = useSelector(pmToolSensorIdSelector);
  const raCost = useRaCostSetting();

  const useCols = mapResourceTypeToColsHook[pmProvider][resourceType.type];
  const cols = useCols({ raCost });
  return cols;
};

export default useTableCols;
